import React, { useState } from "react";
import { useModalEsc, backdropClose } from "../utils/modalStack";

export default function MobilAddModal({ cars = [], onSubmit, onClose }) {
  const [value, setValue] = useState("");

  useModalEsc(onClose);

  const nm = value.trim();
  const dup = nm && cars.some((c) => String(c.name).trim().toLowerCase() === nm.toLowerCase());
  const canSubmit = nm !== "" && !dup;

  const handleSubmit = () => {
    if (!canSubmit) return;
    onSubmit(nm);
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onMouseDown={backdropClose(onClose)}>
      <div className="modal-box" onMouseDown={(e) => e.stopPropagation()}>
        <h2 className="modal-title">Tambah Mobil</h2>
        <div className="form-row" style={{ marginTop: "var(--gap-lg)" }}>
          <label className="form-label" htmlFor="mobil-add-nama">Nama mobil</label>
          <input
            id="mobil-add-nama"
            className="form-input"
            autoFocus
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter" && canSubmit) { e.preventDefault(); handleSubmit(); } }}
          />
          {dup && <div className="form-hint" style={{ color: "var(--red)" }}>Mobil ini sudah ada.</div>}
          {/* Disabled-control sweep (manual-testing report) — shared convention. nm==="" implies
              !dup, so these two hints never show at once. */}
          {nm === "" && <div className="form-hint" style={{ color: "var(--red)" }}>Wajib diisi.</div>}
        </div>
        <div className="modal-actions">
          <button type="button" className="btn" onClick={onClose}>Batal</button>
          <button type="button" className="btn btn-primary" disabled={!canSubmit} onClick={handleSubmit}>
            Tambah
          </button>
        </div>
      </div>
    </div>
  );
}
